<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Service Details" />
            <ServicesDetails />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import ServicesDetails from '../ServicesDetails/ServicesDetails'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'ServicesDetailsPage',
    components: {
        NavBar,
        PageTitle,
        ServicesDetails,
        FooterComp,
    }
}
</script>